module.exports = __webpack_public_path__ + "static/linux-icon-038f0f990f8ebbac7f981d34f6a132e9.svg";